
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/Home.lazy",
      function () {
        return require("private-next-pages/home/Home.lazy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/Home.lazy"])
      });
    }
  